import { motion } from "framer-motion";
import { Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import useSEO from "../hooks/useSEO";
import "./Contatti.css";

const Contatti = () => {
  useSEO({
    title: "La Psicologa Anna | Contatti",
    description:
      "Contatta la Dott.ssa Anna Antoniozzi per informazioni e prenotazioni. Studio a Rieti, Via Fundania 2 - C.C. Perseo, e sedute online.",
    canonicalPath: "/contatti",
  });

  return (
    <div className="contatti">
      <section className="section section--paper contatti-hero">
        <div className="container contatti-grid">
          <motion.div
            className="contatti-info"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="eyebrow">Parliamone</p>
            <h1 className="display contatti-title">Contatti</h1>
            <p className="lead contatti-lead">
              Per informazioni o per fissare un appuntamento, scegli il canale
              che preferisci: ti rispondo il prima possibile.
            </p>

            <ul className="contatti-rows">
              <li>
                <span className="contatti-ico">
                  <Mail size={20} />
                </span>
                <div>
                  <span className="contatti-label">Email</span>
                  <a href="mailto:annaantoniozzipsicologa@gmail.com">
                    annaantoniozzipsicologa@gmail.com
                  </a>
                </div>
              </li>
              <li>
                <span className="contatti-ico">
                  <Phone size={20} />
                </span>
                <div>
                  <span className="contatti-label">Telefono</span>
                  <a href="tel:+393791566652">+39 379 156 6652</a>
                </div>
              </li>
              <li>
                <span className="contatti-ico">
                  <MapPin size={20} />
                </span>
                <div>
                  <span className="contatti-label">Studio</span>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=42.40418065464321%2C12.851407020320385"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Via Fundania 2, Rieti (RI) 02100 - C.C. Perseo, Torre A
                  </a>
                </div>
              </li>
            </ul>

            <div className="contatti-social">
              <a
                href="https://www.instagram.com/lapsicologaanna/"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Instagram"
              >
                <Instagram size={22} />
              </a>
              <a
                href="https://www.linkedin.com/in/anna-antoniozzi-5429a9236/"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="LinkedIn"
              >
                <Linkedin size={22} />
              </a>
            </div>
          </motion.div>

          <motion.div
            className="contatti-map"
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              duration: 0.8,
              ease: [0.22, 1, 0.36, 1],
              delay: 0.12,
            }}
          >
            <iframe
              src="https://www.google.com/maps?q=42.40418065464321,12.851407020320385&z=17&output=embed"
              width="600"
              height="600"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{ border: 0 }}
              title="Mappa dello studio - Centro Commerciale Perseo, Via Fundania 2, Rieti"
            ></iframe>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contatti;
